import script from "./PopupLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupLayer.vue?vue&type=script&setup=true&lang=js"

import "./PopupLayer.vue?vue&type=style&index=0&id=c094c98a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c094c98a"]])

export default __exports__